// This file is generated, do not edit!
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import { type Material, MaterialDaten } from "../../api";
import { useGetApi } from "../client";
import { useCallback } from "react";

export function useUpdateMaterial(): (
  id: string,
  requestBody: MaterialDaten
) => Promise<Material> {
  const getAPI = useGetApi();
  return useCallback(
    async (id, requestBody) =>
      (await getAPI()).material.updateMaterial({ id, requestBody }),
    [getAPI]
  );
}
